import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const NewIndex = lazy(() => import('./new/Index'))
const ManageIndex = lazy(() => import('./:id/manage/Index'))

export const PersonRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--entities--person']}>
    <Route index element={<Index />} />
    <Route path='new' element={<NewIndex />} />
    <Route path=':id/*' element={<ManageIndex />} />
  </SubRouter>
))
